module.exports = __webpack_public_path__ + "img/7.8fcef2e9.jpg";